import { Playlist } from '@raydiant/api-client-js';
import PlaylistItemV2 from './PlaylistItemV2';
import { useScheduleVisibility } from './ScheduleVisibilityContext';
import { ItemIDPath } from '../../../playlistPageTypes';

interface PlaylistItemListInternalV2Props {
  playlist: Playlist;
  itemIdPath?: ItemIDPath;
  playlistIdPath?: ItemIDPath;
}

const PlaylistItemListInternalV2 = ({
  playlist,
  itemIdPath = [],
  playlistIdPath = [],
}: PlaylistItemListInternalV2Props) => {
  const shouldHidePlaylist = useScheduleVisibility();
  const visibleItems = playlist.items.filter(
    (item) => !shouldHidePlaylist(item.playlist),
  );

  if (visibleItems.length === 0) {
    // Empty skeleton placeholder
    return <div className="flex-1 mx-2 mt-0.5" />;
  }

  const isRootPlaylist = itemIdPath.length === 0;
  const playlistItems = visibleItems.map((item) => (
    <PlaylistItemV2
      key={item.id}
      item={item}
      itemIdPath={[...itemIdPath, item.id]}
      playlistIdPath={[...playlistIdPath, playlist.id]}
      parentPlaylist={playlist}
    />
  ));

  if (isRootPlaylist) {
    return <div className="pb-8 px-2 pt-0.5">{playlistItems}</div>;
  }

  return <>{playlistItems}</>;
};

export default PlaylistItemListInternalV2;
